import { render } from "./EditProperty.vue?vue&type=template&id=de2dd770"
import script from "./EditProperty.vue?vue&type=script&lang=js"
export * from "./EditProperty.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__